import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/esm/Col';
import Image from 'react-bootstrap/esm/Image';

const Divider = ({ data }) => {
 return (
  <Container className='p-3'>
   <Row>
    <Col>
     <hr />
    </Col>

    <Col>
     <Image src='./assets/logoImg.png' width={80} alt='Logo' fluid />
    </Col>

    <Col>
     <hr />
    </Col>
   </Row>
  </Container>
 );
};

export default Divider;
